import { Grid } from "@material-ui/core";
import { useField } from "formik";
import mapboxgl from "mapbox-gl";
import React, { useEffect, useRef, useState } from "react";

const defaultLocation = { lat: 36.8242, lng: 10.1785 };
const zoom = 10;

const EntryMap = ({
  topLabel,
  name,
  // ...
  xs = 12,
  md = 6,
  // ...
}) => {
  const [field, meta, helpers] = useField({ name });
  const [location, setLocation] = useState(() => {
    if (field?.value?.lat && field?.value?.lng) {
      return { lat: field.value.lat, lng: field.value.lng };
    }
    return defaultLocation;
  });
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!field?.value?.lat || !field?.value?.lng) {
      if (typeof navigator !== "undefined" && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            setLocation(userLocation);
            helpers.setValue(userLocation);
          },
          () => {}
        );
      }
    }
  }, []);

  useEffect(() => {
    if (!mapContainerRef.current || mapRef.current) return;

    if (process.env.REACT_APP_MAP_MAPBOX) {
      mapboxgl.accessToken = process.env.REACT_APP_MAP_MAPBOX;
    }

    const initialLocation = location || defaultLocation;

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [initialLocation.lng, initialLocation.lat],
      zoom,
    });

    markerRef.current = new mapboxgl.Marker({ draggable: false })
      .setLngLat([initialLocation.lng, initialLocation.lat])
      .addTo(mapRef.current);

    const handleMapClick = (event) => {
      const nextLocation = {
        lat: event.lngLat.lat,
        lng: event.lngLat.lng,
      };
      setLocation(nextLocation);
      helpers.setValue(nextLocation);
    };

    mapRef.current.on("click", handleMapClick);

    return () => {
      if (mapRef.current) {
        mapRef.current.off("click", handleMapClick);
        mapRef.current.remove();
        mapRef.current = null;
      }
      markerRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!location) return;

    if (markerRef.current) {
      markerRef.current.setLngLat([location.lng, location.lat]);
    }
    if (mapRef.current) {
      mapRef.current.setCenter([location.lng, location.lat]);
    }
  }, [location]);

  useEffect(() => {
    if (field?.value?.lat && field?.value?.lng) {
      setLocation({ lat: field.value.lat, lng: field.value.lng });
    }
  }, [field?.value?.lat, field?.value?.lng]);

  return (
    <Grid item xs={xs} md={md}>
      {topLabel && (
        <label
          style={{
            display: "block",
            color: "#333",
            fontFamily: "Poppins, sans-serif",
            fontSize: "13px",
            lineHeight: "20px",
            fontWeight: "500",
            margin: "0 0 5px 0"
          }}>
          {topLabel}
        </label>
      )}
      <div
        ref={mapContainerRef}
        style={{
          width: "100%",
          height: 360,
          borderRadius: 8,
          overflow: "hidden",
        }}
      />

    </Grid>
  );
};

export default EntryMap;
